/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
export const styles = css`
    .price-filter__title {
        display: flex;
        gap: var(--layout-spacing-8);
        align-items: center;
        ${theme.typography.body_large}
        color: var(--colors-text-secondary);
        margin-bottom: var(--layout-spacing-16);

        &.price-filter__title--hidden {
            display: none;
        }
    }

    .price-filter__price-icon svg {
        fill: var(--colors-surface-accent-inverse);
    }

    .price-filter__options {
        display: flex;
        gap: var(--layout-spacing-8);
        margin-bottom: var(--layout-spacing-16);
    }

    .price-filter__options--custom-range {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: var(--layout-spacing-16);

        .input {
            margin: 0;
            input {
                margin-top: var(--layout-spacing-24);
            }
        }
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
